import { render } from "./ExaminationGuide.vue?vue&type=template&id=7447b00d"
import script from "./ExaminationGuide.vue?vue&type=script&lang=js"
export * from "./ExaminationGuide.vue?vue&type=script&lang=js"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__